import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const propertyAreaUnitService = {
    getAll,
    store,
    show,
    update,
    updateStatus,
    softDelete,
    destroy,
};

const MODULE = {
    PROPERTY_AREA_UNIT: 'property-area-units',
};

const API_URL = API.BASE_URL_API + '/v1';

export function getAll (filter) {
    const request = {
        params: {
            page: filter?.pageNumber,
            size: filter?.pageSize,
            is_active: filter?.isActive,
        },
    };

    let array = filter?.searchArray;
    array?.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`;
            request.params[searchParam] = word;
        }
    });

    return apiHelper(API_URL).get(`/${MODULE.PROPERTY_AREA_UNIT}`, request);
}

export function store (data) {
    const request = {
        name: data.name,
        description: data.description,
        conversion_factor: data.conversionFactor,
        is_base: data.isBase,
        is_statistic: data.isStatistic,
    };

    return apiHelper(API_URL).post(`/${MODULE.PROPERTY_AREA_UNIT}`, request);
}

export function show (uuid) {
    return apiHelper(API_URL).get(`/${MODULE.PROPERTY_AREA_UNIT}/${uuid}`);
}

export function update (data) {
    const request = {
        name: data.name,
        description: data.description,
        conversion_factor: data.conversionFactor,
        is_base: data.isBase,
        is_statistic: data.isStatistic,
    };

    return apiHelper(API_URL).put(`/${MODULE.PROPERTY_AREA_UNIT}/${data.uuid}`, request);
}

export function updateStatus (data) {
    const request = {
        is_active: data.isActive,
    };

    return apiHelper(API_URL).patch(`/${MODULE.PROPERTY_AREA_UNIT}/status/${data.uuid}`, request);
}

export function softDelete (data) {
    return apiHelper(API_URL).patch(`/${MODULE.PROPERTY_AREA_UNIT}/delete/${data.uuid}`);
}

export function destroy (data) {
    return apiHelper(API_URL).delete(`/${MODULE.PROPERTY_AREA_UNIT}/${data.uuid}`);
}
